

const CustomLoader = () => {
    return (
        <div className="loader-container">
            <img src="/images/logo.png" alt="Loading..." className="loader-logo" />
        </div>
    )
}

export default CustomLoader